module.exports = __webpack_public_path__ + "static/media/Read-Bold_V3000.e2b98689.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/read/Read-Bold_V3000.woff2
// module id = 756
// module chunks = 6